export default "__VITE_ASSET__COLhVKUP__"